<template>
  <div class="f item_name">
    <ItemCardComponentsExteriorAB
        :name="item.market_hash_name"
    />
    <p
        :class="{
          stattrak: item?.is_stattrak,
          souvenir: item?.is_souvenir,
          white: !item?.is_stattrak && !item?.is_souvenir
        }"
        class="name_model"
        @click="copy"
    >
      {{ item.localed_name }}
    </p>
    <button
        aria-label="Copy"
        class="btn btn-default btn-square btn_copy p0"
        @click="copy"
    >
      <svg height="20" width="20">
        <use xlink:href="/icons/sprite.svg#i-copy"></use>
      </svg>
    </button>
  </div>
</template>

<script lang="ts" setup>
import {notify} from '@kyvg/vue3-notification'
import {useI18n} from 'vue-i18n'
import type {CompareItem} from "~/graphql/generated/schema-types";

const {t} = useI18n()

const props = defineProps<{
  item: CompareItem
}>()

const copy = () => {
  navigator.clipboard.writeText(props.item.market_hash_name)
      .then(() => {
        notify({
          type: 'success',
          title: t('notify.success'),
          text: t('notify.copied')
        })
      })
      .catch(() => {
        notify({
          type: 'error',
          title: t('notify.error'),
          text: t('An error occurred')
        })
      })
}
</script>

<style lang="scss" scoped>
.item_name {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #8E9EBD;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;

  &:hover {
    color: var(--surfaces-on-surface-variable);
  }

  &:deep(.ext) {
    transition: 0.3s;
    width: 25px;
    text-align: center;
  }

  .name_model {
    font-weight: inherit;
    width: 165px;

    &:not(.stattrak):not(.souvenir) {
      color: var(--surfaces-on-surface-variable);
    }

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .btn_copy {
    color: inherit;
  }

  @media screen and (max-width: 1115px) {
    width: calc(100% - 124px);
    .name_model {
      width: 100%;
      justify-content: flex-start;
    }
    .btn_copy {
      display: none;
    }
    &:deep(.ext) {
      width: unset;
    }
  }
}

</style>
